import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=f3cf74c6&scoped=true&"
import script from "./Checkboxes.vue?vue&type=script&lang=js&"
export * from "./Checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=f3cf74c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cf74c6",
  null
  
)

export default component.exports